<!--国家信息-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="国家名称">
            <a-input v-decorator="['countryName']" placeholder="请输入国家名称" allowClear></a-input>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">国家领区列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="addRow">
          <app-icon type="icon-tianjia"></app-icon>
          添加国家
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="useRowIndex"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
    <ModalSelectCountry ref="modalSelectCountry"></ModalSelectCountry>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import ModalSelectCountry from '@/components/modalSelect/Country.vue'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '8%',
        align: 'center',
        // dataIndex: 'userName',
        customRender: (text, row, index) => {
          return <div>{this.pageSize * (this.pageNumber - 1) + index + 1}</div>
        },
      },
      {
        title: '国家',
        width: '12%',
        align: 'center',
        dataIndex: 'countryName',
      },
      {
        title: '领区',
        align: 'center',
        dataIndex: 'consularRegionList',
        customRender: text => {
          return (
            <span>
              {text?.map((item, index) => {
                const sep = index === 0 ? '' : '、'
                return sep + item.consularRegionName
              })}
            </span>
          )
        },
      },
      {
        title: '操作',
        width: '10%',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-5 justify-center items-center text-primary-500">
              <span
                type="icon-bianji"
                onClick={() => {
                  this.editRow(row)
                }}
              >
                编辑
              </span>
              <span
                type="icon-shanchu"
                onClick={() => {
                  this.removeRow(row, index)
                }}
              >
                删除
              </span>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
    }
  },
  components: {
    Page,
    ModalSelectCountry,
  },
  computed: {
    typesMap() {
      return {}
    },
  },
  async mounted() {
    this.doQuery()
  },
  methods: {
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const form = this.form.getFieldsValue()
        const res = await this.$axios.get(`/visa/admin/consular/region/country`, {
          params: {
            page: _pageNumber,
            limit: _pageSize,
            ...form,
          },
        })
        this.countTotal = Number(res.count)
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    editRow(row) {
      this.$router.push({
        path: '/m/scopeMain/areaManage/addArea',
        query: {
          countryId: row.countryId,
        },
      })
    },
    async removeRow(row, index) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      if (row.consularRegionList && row.consularRegionList.length > 0) {
        await this.$axios.delete(`/visa/admin/consular/region/country`, {
          params: {
            countryId: row.countryId,
          }
        })
      } else {
        this.dataSource.splice(index, 1)
      }

      this.$message.success('操作成功!')
      this.doQuery()
    },
    async addRow() {
      const country = await this.$refs.modalSelectCountry.start()
      console.log(country)
      const obj = {
        countryId: country.value,
        countryName: country.label,
      }

      try {
        this.dataSource.unshift(obj)
        this.dataSource = [...this.dataSource]
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>

<style lang="less"></style>
